// Documentos jurídicos oficiais — Ministério AURA (textos fornecidos pelo usuário, verbatim)
// Placeholders entre [COLCHETES] aguardam dados oficiais — NÃO inventar valores.

export const TERMS_VERSION = "2026-09-29";
export const PRIVACY_VERSION = "2026-09-29";

export const TERMS_DOC = {
  slug: "termos-de-uso",
  title: "Termos de Uso — Ministério AURA",
  updated: "29 de setembro de 2026",
  sections: [
    {
      heading: "1. Sobre o AURA",
      body: [
        "Bem-vinda ao Ministério AURA.",
        "Estes Termos de Uso estabelecem as condições para utilização do site e dos recursos disponibilizados por meio da Landing Page do AURA, incluindo a apresentação do projeto e o envio de candidaturas para participação como Miss Aura ou Embaixadora.",
        "Ao acessar este site ou enviar uma candidatura, você declara que leu e compreendeu estes Termos e que concorda com as condições aqui estabelecidas.",
      ],
    },
    {
      heading: "2. Sobre as candidaturas",
      body: [
        "A Landing Page poderá disponibilizar formulários destinados à manifestação de interesse e candidatura para diferentes modalidades de participação no AURA.",
        "Atualmente, poderão ser disponibilizadas candidaturas para:",
        "O envio de uma candidatura não significa aprovação automática.",
        "As informações fornecidas serão analisadas pela equipe responsável pelo projeto de acordo com os critérios e processos internos aplicáveis a cada modalidade.",
        "A AURA poderá entrar em contato com a candidata utilizando os dados fornecidos no formulário para fins relacionados ao processo de candidatura.",
      ],
      list: ["Miss Aura;", "Embaixadora."],
      listAfter: 1,
    },
    {
      heading: "3. Responsabilidade pelas informações fornecidas",
      body: [
        "A candidata é responsável pela veracidade, exatidão e atualização das informações fornecidas.",
        "Não devem ser inseridas informações falsas, fraudulentas, ofensivas ou pertencentes a terceiros sem autorização.",
        "Caso sejam identificadas informações incorretas ou inconsistentes, a equipe poderá solicitar esclarecimentos ou desconsiderar a candidatura.",
      ],
    },
    {
      heading: "4. Participação no projeto",
      body: [
        "A eventual aprovação de uma candidata dependerá da análise realizada pela equipe responsável pelo AURA.",
        "A aprovação ou participação poderá estar sujeita a regras, critérios, compromissos e orientações específicas que serão apresentados posteriormente, quando aplicáveis.",
        "Estes Termos não garantem aprovação ou participação em qualquer modalidade do projeto.",
      ],
    },
    {
      heading: "5. Conteúdo do site",
      body: [
        "Os textos, imagens, vídeos, identidade visual, marcas, elementos gráficos e demais conteúdos disponibilizados nesta Landing Page pertencem ao AURA ou são utilizados de acordo com autorização/licença aplicável.",
        "É proibida a reprodução, distribuição, modificação ou utilização comercial não autorizada desses conteúdos.",
      ],
    },
    {
      heading: "6. Links e serviços de terceiros",
      body: [
        "A Landing Page poderá apresentar links ou integrações com serviços externos, incluindo plataformas de vídeo, redes sociais, aplicativos ou outros serviços utilizados pelo projeto.",
        "Cada serviço externo possui seus próprios termos de uso e políticas de privacidade.",
        "O AURA não controla integralmente as práticas de terceiros e recomenda que o usuário consulte as respectivas políticas antes de fornecer informações diretamente a essas plataformas.",
      ],
    },
    {
      heading: "7. Aplicativo AuraConect",
      body: [
        "Quando houver referência ou link para o aplicativo AuraConect, o acesso ao aplicativo estará sujeito aos respectivos termos, políticas e condições de utilização.",
        "A Landing Page e o aplicativo podem constituir ambientes tecnológicos distintos.",
        "O simples acesso à Landing Page não significa criação automática de uma conta no AuraConect.",
      ],
    },
    {
      heading: "8. Disponibilidade",
      body: [
        "A equipe buscará manter a Landing Page disponível e funcionando adequadamente, mas não garante disponibilidade ininterrupta.",
        "Poderão ocorrer interrupções temporárias para manutenção, atualização, segurança ou motivos técnicos fora do controle da equipe.",
      ],
    },
    {
      heading: "9. Segurança",
      body: [
        "Serão adotadas medidas técnicas e administrativas razoáveis para proteger as informações tratadas por meio da plataforma.",
        "Nenhum ambiente tecnológico, entretanto, pode garantir segurança absoluta contra todos os riscos existentes.",
      ],
    },
    {
      heading: "10. Alterações destes Termos",
      body: [
        "Estes Termos poderão ser atualizados periodicamente para refletir alterações no projeto, nos serviços oferecidos, na legislação ou nas práticas da organização.",
        "A versão mais recente estará disponível na Landing Page.",
      ],
    },
    {
      heading: "11. Contato",
      list: [
        "Responsável: Vanessa Iara de Freitas Vieira-ME",
        "CNPJ: 68.855.084/0001-89",
        "Nome fantasia/projeto: Ministério AURA",
        "E-mail: suporte@auraconect.com.br",
        "Endereço: Rua Dona Sofia, 85 — Santa Tereza — Porto Alegre/RS — CEP: 90.840-060",
      ],
    },
    {
      heading: "12. Aceite",
      body: [
        "Ao utilizar os recursos da Landing Page e, quando aplicável, marcar a opção de concordância apresentada no formulário, a usuária declara estar ciente destes Termos de Uso.",
      ],
    },
  ],
};

export const PRIVACY_DOC = {
  slug: "politica-de-privacidade",
  title: "Política de Privacidade — Ministério AURA",
  updated: "29 de setembro de 2026",
  intro:
    "A presente Política de Privacidade explica como o Ministério AURA coleta, utiliza, armazena, protege e eventualmente compartilha dados pessoais fornecidos por pessoas que utilizam esta Landing Page.",
  sections: [
    {
      heading: "1. Quem é o responsável pelos dados",
      body: [
        "Para os tratamentos realizados por meio desta Landing Page, o controlador dos dados será:",
        "O controlador é o responsável pelas principais decisões relacionadas ao tratamento dos dados pessoais.",
      ],
      list: [
        "Vanessa Iara de Freitas Vieira-ME",
        "CNPJ: 68.855.084/0001-89",
        "Nome fantasia/projeto: Ministério AURA",
        "E-mail: suporte@auraconect.com.br",
        "Endereço: Rua Dona Sofia, 85 — Santa Tereza — Porto Alegre/RS — CEP: 90.840-060",
      ],
      listAfter: 0,
    },
    {
      heading: "2. Quais dados podem ser coletados",
      body: [
        "Dependendo do formulário utilizado, poderão ser tratados dados fornecidos voluntariamente pela candidata, como:",
        "Também poderão ser tratados dados técnicos relacionados à utilização do site, como endereço IP, informações do navegador, dispositivo e registros técnicos necessários à segurança e funcionamento da plataforma.",
      ],
      list: [
        "nome;",
        "e-mail;",
        "telefone/WhatsApp;",
        "cidade e estado;",
        "informações profissionais;",
        "informações relacionadas à candidatura;",
        "informações fornecidas nos campos de apresentação;",
        "informações relacionadas à indicação;",
        "código de referral, quando existente;",
        "código de convite/refAmb, quando existente;",
        "informações necessárias para análise da candidatura.",
      ],
      listAfter: 0,
    },
    {
      heading: "3. Dados sensíveis",
      body: [
        "A AURA poderá receber informações que, dependendo do conteúdo fornecido pela própria candidata, possam revelar aspectos considerados sensíveis pela LGPD.",
        "A LGPD confere proteção específica aos dados pessoais sensíveis.",
        "A organização deverá evitar solicitar dados sensíveis que não sejam efetivamente necessários para uma finalidade determinada.",
        "Quando o tratamento de determinado dado exigir uma base legal específica, serão observadas as exigências aplicáveis.",
      ],
    },
    {
      heading: "4. Para que utilizamos os dados",
      body: ["Os dados poderão ser utilizados para:"],
      list: [
        "a) Receber candidaturas;",
        "b) Entrar em contato;",
        "c) Gerenciar o processo de seleção;",
        "d) Identificar indicações;",
        "e) Segurança;",
        "f) Cumprimento de obrigações legais.",
      ],
    },
    {
      heading: "5. Bases legais",
      body: [
        "O tratamento de dados será realizado conforme as bases legais aplicáveis a cada finalidade, que poderão incluir, conforme o caso:",
      ],
      list: [
        "consentimento;",
        "procedimentos relacionados à execução de contrato ou procedimentos preliminares;",
        "cumprimento de obrigação legal ou regulatória;",
        "exercício regular de direitos;",
        "legítimo interesse, quando aplicável;",
        "outras hipóteses previstas na LGPD.",
      ],
    },
    {
      heading: "6. Compartilhamento de dados",
      body: [
        "Os dados poderão ser compartilhados, quando necessário e dentro das finalidades informadas, com:",
      ],
      list: [
        "prestadores de serviços tecnológicos;",
        "provedores de hospedagem e infraestrutura;",
        "sistemas de gerenciamento/CRM;",
        "fornecedores responsáveis por serviços de comunicação;",
        "prestadores de serviços necessários à operação do projeto;",
        "autoridades públicas, quando houver obrigação legal.",
      ],
    },
    {
      heading: "7. Aplicativo AuraConect",
      body: [
        "A Landing Page poderá realizar determinadas integrações técnicas com o aplicativo AuraConect.",
        "Quando necessário para uma finalidade específica, determinadas informações relacionadas à candidatura ou indicação poderão ser transmitidas ao aplicativo, observadas as bases legais e as finalidades correspondentes.",
        "O tratamento realizado diretamente pelo aplicativo AuraConect poderá estar sujeito à sua própria documentação de privacidade e aos seus próprios agentes de tratamento.",
      ],
    },
    {
      heading: "8. CRM de candidaturas",
      body: [
        "As candidaturas poderão ser armazenadas e organizadas em sistema de CRM utilizado exclusivamente para gerenciamento interno do processo de seleção.",
        "O acesso ao CRM deverá ser restrito a pessoas autorizadas.",
        "As candidaturas não deverão ficar disponíveis publicamente.",
        "As informações serão utilizadas para acompanhamento e gestão das candidaturas e não serão disponibilizadas publicamente sem fundamento legal ou autorização aplicável.",
      ],
    },
    {
      heading: "9. Retenção dos dados",
      body: [
        "Os dados serão mantidos pelo período necessário para cumprir as finalidades para as quais foram coletados, observadas as obrigações legais, regulatórias e as necessidades legítimas de documentação e exercício de direitos.",
        "Quando não houver mais necessidade ou fundamento jurídico para a manutenção dos dados, eles poderão ser eliminados, anonimizados ou submetidos a outras medidas permitidas pela legislação.",
      ],
    },
    {
      heading: "10. Segurança",
      body: [
        "São adotadas medidas técnicas e administrativas destinadas a proteger os dados pessoais contra:",
      ],
      list: [
        "acesso não autorizado;",
        "perda;",
        "destruição;",
        "alteração indevida;",
        "divulgação indevida;",
        "tratamento inadequado ou ilícito.",
      ],
    },
    {
      heading: "11. Direitos do titular",
      body: [
        "Nos termos da LGPD, o titular poderá exercer, conforme aplicável, direitos como:",
      ],
      list: [
        "confirmação da existência de tratamento;",
        "acesso aos dados;",
        "correção de dados incompletos, inexatos ou desatualizados;",
        "informações sobre tratamento;",
        "informações sobre compartilhamentos;",
        "anonimização, bloqueio ou eliminação em hipóteses aplicáveis;",
        "portabilidade, observadas as regras aplicáveis;",
        "revogação do consentimento, quando o tratamento estiver baseado em consentimento;",
        "oposição, quando cabível;",
        "revisão e explicação relativas a determinadas decisões automatizadas, quando aplicável.",
      ],
    },
    {
      heading: "12. Como exercer seus direitos",
      body: [
        "Para solicitar informações ou exercer seus direitos, entre em contato:",
        "E-mail de privacidade: suporte@auraconect.com.br",
        "Ao receber uma solicitação, poderemos solicitar informações razoáveis para confirmar a identidade do solicitante e proteger os dados contra acesso indevido.",
      ],
    },
    {
      heading: "13. Encarregado de dados",
      list: ["Encarregado/DPO: Marcelo Bersch", "E-mail: transmillapp@gmail.com"],
    },
    {
      heading: "14. Cookies e tecnologias semelhantes",
      body: [
        "A Landing Page poderá utilizar cookies e tecnologias semelhantes necessários ao funcionamento, segurança, preferências e análise de utilização do site.",
        "Quando forem utilizados cookies que dependam de consentimento, deverá ser disponibilizado mecanismo adequado para sua gestão, conforme a legislação aplicável.",
      ],
    },
    {
      heading: "15. Links externos",
      body: [
        "A Landing Page poderá conter links para YouTube, Instagram, WhatsApp, Facebook, TikTok, LinkedIn ou outros serviços.",
        "Ao acessar esses serviços, o tratamento de dados estará sujeito às políticas de privacidade dos respectivos provedores.",
      ],
    },
    {
      heading: "16. Alterações da Política",
      body: [
        "Esta Política poderá ser atualizada periodicamente para refletir mudanças legais, tecnológicas ou operacionais.",
        "A versão vigente será disponibilizada nesta página, acompanhada da respectiva data de atualização.",
      ],
    },
    {
      heading: "17. Contato",
      list: [
        "Controlador: Vanessa Iara de Freitas Vieira-ME",
        "CNPJ: 68.855.084/0001-89",
        "Projeto: Ministério AURA",
        "E-mail: suporte@auraconect.com.br",
        "E-mail de privacidade: suporte@auraconect.com.br",
      ],
    },
  ],
};
